import * as Sentry from '@sentry/react';

// Source-map upload enabled on the build (SENTRY_AUTH_TOKEN set as a non-secret
// BUILD_TIME var in DigitalOcean, 2026-08-26). This comment also serves as the
// cache-bust that forces `npm run build` to re-run so the plugin uploads maps.

/**
 * Frontend Sentry init — DSN-gated (a safe no-op locally / when VITE_SENTRY_DSN
 * is unset), mirroring the backend's server/instrument.ts pattern.
 *
 * VITE_SENTRY_DSN is inlined by Vite at build time (like the other VITE_* vars
 * in .env.production). The web DSN is public by design — it ships in the bundle.
 *
 * Note: import.meta.env is read via a narrow local cast because this repo's
 * tsconfig has no vite/client types; the cast avoids tsc noise and STILL works
 * (Vite statically inlines import.meta.env at build).
 */
export function initSentry(): void {
  const env = (import.meta as unknown as { env: Record<string, string | undefined> }).env;
  const dsn = env.VITE_SENTRY_DSN;
  if (!dsn) return; // no-op when unset (local dev / DSN not configured)
  // Preview builds still carry the prod DSN from .env.production; never report.
  if (env.VITE_APP_ENV === 'preview') {return;}

  Sentry.init({
    dsn,
    environment: env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Errors are always captured; this only samples performance traces.
    tracesSampleRate: 0.1,
  });
}
